export const readPlatformFieldsByConfig = (config) => {
    let fields = [];
    let response = {};

    config.templates.forEach((template) => {
        template.block_selectors.forEach((blockSelector) => {
            blockSelector.data_selectors.forEach((dataSelector) => {
                if (dataSelector.action_code === "STORE_TO_DB") {
                    // let combination = dataSelector.destination_object_code + ":" + dataSelector.destination_object_property_code;
                    let combination = dataSelector.destination_object_property_code;
                    if (fields.indexOf(combination) === -1) {
                        fields.push(combination);
                        let normalizersNames = [];
                        if (dataSelector.normalizers.length > 0) {
                            dataSelector.normalizers.forEach((n) => {
                                normalizersNames.push(n.code);
                            });
                        }
                        response[combination] = normalizersNames;
                    }
                }
            });
        });
    });

    return response;
};